var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamationMarkGreyOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5a7.5 7.5 0 110 15 7.5 7.5 0 010-15z",
    fill: "#fff",
    stroke: "#C4C9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12V9M9 6h.008",
    stroke: "#C4C9D9",
    strokeWidth: 1.149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguOTk5NTEgMS40OTk3NkMxMy4xNDE2IDEuNDk5NzYgMTYuNDk5NSA0Ljg1NzYyIDE2LjQ5OTUgOC45OTk3NkMxNi40OTk1IDEzLjE0MTkgMTMuMTQxNiAxNi40OTk4IDguOTk5NTEgMTYuNDk5OEM0Ljg1NzM4IDE2LjQ5OTggMS40OTk1MSAxMy4xNDE5IDEuNDk5NTEgOC45OTk3NkMxLjQ5OTUxIDQuODU3NjIgNC44NTczOCAxLjQ5OTc2IDguOTk5NTEgMS40OTk3NloiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNDNEM5RDkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOSAxMS45OTk4VjguOTk5NzYiIHN0cm9rZT0iI0M0QzlEOSIgc3Ryb2tlLXdpZHRoPSIxLjE0ODU3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkgNS45OTk3Nkg5LjAwNzU5IiBzdHJva2U9IiNDNEM5RDkiIHN0cm9rZS13aWR0aD0iMS4xNDg1NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgExclamationMarkGreyOutlined as ReactComponent };